import * as moment from 'moment';

import { ActionType } from '../../classes/add-on-actions';
import { IBasePerformanceDetails } from '../../classes/add-ons';
import { IAddOnProduction, IPerformance } from '../../custom/classes/production';



export function addPerformanceToRequest(performanceId: number) {
    return {
        type: ActionType.AddPerformanceToRequest,
        value: performanceId
    }
}

export function removeAllPerformanceFromRequest() {
    return {
        type: ActionType.RemoveAllPerformanceFromRequest
    }
}

export function displayLoading(enable:  boolean) {
    return {
        type: ActionType.DisplayLoading,
        value: enable
    }
}
export function removePerformanceFromRequest(performanceId: number) {
    return {
        type: ActionType.RemovePerformanceFromRequest,
        value: performanceId
    }
}

export function performanceUnavailable(performanceId: number) {
    return {
        type: ActionType.PerformanceUnAvailable,
        value: performanceId
    }
}
export function failedReserveUpdate(performanceIds: Array<number>) {
    return {
        type: ActionType.FailedReserve,
        value: performanceIds
    }
}

export function updatePriceTypeToRequest(performanceId: number, priceTypeId: number, quantity: number) {
    return {
        type: ActionType.UpdatePriceTypeToRequest,
        value: {
            performanceId: performanceId,
            priceTypeId: priceTypeId,
            quantity: quantity
        }
    }
}

export function updateTotal(performanceId: number, total: number) {
    return {
        type: ActionType.UpdateTotal,
        value: {
            performanceId: performanceId,
            total: total
        }
    }
}
export function updateZoneToRequest(performanceId: number, zoneId: number)
{
    return {
        type: ActionType.UpdateZoneToRequest,
        value: {
            performanceId: performanceId,
            zoneId: zoneId
        }
    }
}

export function receivePerformanceDetail(performancePricing: IBasePerformanceDetails) {
    return {
        type: ActionType.RecievePerformanceDetails,
        value: performancePricing
    }
}

export function loadProductions(productions: Array<IAddOnProduction>) {
    return {
        type: ActionType.LoadProductions,
        value: productions
    }
}

export function updateSettings(settings) {
    return {
        type: ActionType.UpdateSettings,
        value: settings
    }
}   
